export default __webpack_public_path__ + "1158d4366616cc3b5c2e99435efe055a.png";